import { Box, Grid, Skeleton, Stack } from "@mui/material";

const SellerSkeleton = () => {

    return (
        <>
            <div style={{ display: "flex" }}>
                <Skeleton variant="rectangular" style={{ width: "100%" }} height={60} />
            </div>
            <Grid container marginTop={"10px"} sx={{ overflowY: "auto", height: "calc(100svh - 200px)", paddingX: "20px" }}>
                {[...Array(10)].map((_, index) => (
                    <Grid xs={6} item key={index} width={"100%"} height={"fit-content"} sx={{ padding: "5px !important" }}>
                        <Skeleton variant="rectangular" width={"100%"} height={"16svh"} sx={{ transform: "unset", borderRadius: "5px", aspectRatio: "1" }} />
                    </Grid>
                ))
                }
            </Grid>
        </>
    )
}

export default SellerSkeleton;